
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Building } from "lucide-react";

interface OrganizationSectionProps {
  organizationName: string;
  setOrganizationName: (name: string) => void;
}

const OrganizationSection = ({ 
  organizationName, 
  setOrganizationName 
}: OrganizationSectionProps) => {
  return (
    <div>
      <Label htmlFor="organizationName" className="block text-sm font-medium text-gray-700">
        Nom de l'organisation *
      </Label>
      <div className="mt-1 flex rounded-md shadow-sm">
        <span className="inline-flex items-center rounded-l-md border border-r-0 border-gray-300 bg-gray-50 px-3 text-gray-500">
          <Building className="h-4 w-4" />
        </span>
        <Input
          id="organizationName"
          name="organizationName"
          type="text"
          required
          className="block w-full flex-1 rounded-none rounded-r-md border-gray-300 focus:border-socialsync-500 focus:ring-socialsync-500 sm:text-sm"
          placeholder="Ma Société"
          value={organizationName}
          onChange={(e) => setOrganizationName(e.target.value)}
        />
      </div>
    </div>
  );
};

export default OrganizationSection;
